import { httpCreate } from './http';
import conf from '@/config';
const http = httpCreate(conf.surveyApipath + '/surveyAnswer/');
export const surveyAnswer = {
	//增加答案
	addAnswer(data) {
		return http.post('', data);
	},
	//编辑答案
	editAnswer(data, source) {
		return http.post(`editSurveyAnswer?source=${source}`, data);
	},
	//获取全部答案source
	getSourceList(surveyId) {
		return http.get(`${surveyId}`, { params: { page: 0 } });
	},
	//数据统计-列表头
	getDataStatistics(surveyId) {
		return http.get(`getTitle/${surveyId}`);
	},
	//数据统计-答案列表
	getDataAnswer(surveyId, pageNum, pageSize) {
		return http.get(`${surveyId}`, { params: { pageNum, pageSize } });
	},
	//答案列表-条件查询
	getQueryAnswer(surveyId, data, params) {
		return http.post(`list/${surveyId}`, data, { params });
	},
	//批量删除
	batchDeleting(data) {
		return http.delete('batchDelete', { data });
	},
	//execl导出
	getExcelForm(surveyId) {
		return http.get('exportExcel/', { params: { surveyId } });
	},
	//数据统计编辑查看
	geteditorView(surveyId, source) {
		return http.get('getSurveyAnswer', { params: { surveyId: surveyId, source: source } });
	},
	//项目统计-列表
	getProjectStatistics(surveyId) {
		return http.get(`statistics/${surveyId}`);
	},
	// 用户是否已经答题
	isAnswer(surveyId) {
		return http.get(`isAnswer/${surveyId}`);
	},
};
